import { BODY_SKINS, PLACEMENT_TYPE_HERO } from "../helpers/consts";
import Sprite from "../components/object-graphics/Sprite";
import { Placement } from "./Placement";
import { TILES } from "../helpers/tiles";

export class ThiefPlacement extends Placement {
  resetsInventoryOnCollide(body) {
    return body.type === PLACEMENT_TYPE_HERO;
  }

  changeHeroSkinOnCollide() {
    return BODY_SKINS.SCARED;
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.THIEF} />;
  }
}
